require('./brokerWarrantsSellStep2.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');

// @commons
const StocksBuySellSummary = require('components/broker/commons/stocksBuySellSummary/stocksBuySellSummary');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { BROKER_STOCKS_BUY_SELL_SUMMARY_SELL_MODIFIER, FIRST_STEP, CONTENT_TYPE_PDF } = require('constants/index');
const { downloadAsFile, base64ToBlob } = require('utilities/APIRequestHelper');
const { TYPE_WARRANTS } = require('constants/index');

// @ components
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;
const BrokerWarrantsSellExAnteDetails = require('components/broker/brokerWarrantsSell/brokerWarrantsSellExAnteDetails/brokerWarrantsSellExAnteDetails');
const { OKMessage } = require('commonsComponents/OKMessage');

// @ constants
const { BROKER_STOCKS_BUY_ID } = require('constants/operationTypes');
const { CHARGE_ACCOUNT_PREFIX } = require('constants/index');
const { ETFS_SELL_SHOW_COST } = require('constants/flagBasedFeatures');

class BrokerWarrantsSellStep2 extends React.Component {
    constructor(props) {
        super(props);
        this.handleTermsChecked = this.handleTermsChecked.bind(this);
        this.handleDisclaimerClick = this.handleDisclaimerClick.bind(this);
    }

    componentDidMount() {
        const { getExAnteData, history, immFlagBasedFeatures } = this.props;
        if(immFlagBasedFeatures.get(ETFS_SELL_SHOW_COST)){
            getExAnteData(history)
        }
    }

    handleDisclaimerClick(){
        const dataBlock = this.props.immBrokerWarrantsSell.get('sellWarrantsTransactionCostBase64Data');
        const dataID = this.props.immBrokerWarrantsSell.get('sellWarrantsTransactionCostObjectId');
        const base64String = `data:${CONTENT_TYPE_PDF};base64,${dataBlock}`;
        downloadAsFile(base64ToBlob(base64String), CONTENT_TYPE_PDF, dataID);
    }

    handleTermsChecked(e) {
        this.props.handleChangeReadChecked(e.target.checked);
    }

    buildDetailsSection() {
        const {
            immFlagBasedFeatures,
            productFile,
            immStocksContracts,
            immBrokerWarrantsSell,
        } = this.props;
        const productCurrency = productFile.get("currencyCode");
        const stocksContractSelectedValue = immBrokerWarrantsSell.getIn([
            "steps",
            FIRST_STEP,
            "stocksContractSelectedValue",
        ]);
        const stockContract = immStocksContracts.find((contract) => {
            return (
                contract.get("contactNumber") === stocksContractSelectedValue
            );
        });
        const step1 = immBrokerWarrantsSell.get('steps').get(FIRST_STEP);
        return  immFlagBasedFeatures.get(ETFS_SELL_SHOW_COST)
            ? (
                <BrokerWarrantsSellExAnteDetails
                    productCurrency={productCurrency}
                    stockContract={stockContract}
                    stockDescription={productFile.get('companyName')}
                    step1={step1}
                    productFile={productFile}
                    immBrokerWarrantsSell={immBrokerWarrantsSell}
                />
            ) : (
                <StocksBuySellSummary
                    productName={formatText('broker-warrantProductName')}
                    productCurrency={productCurrency}
                    stockContract={stockContract}
                    stockDescription={productFile.get('companyName')}
                    step1={step1}
                    modifier={BROKER_STOCKS_BUY_SELL_SUMMARY_SELL_MODIFIER}
                    maskLimitOrderType={true}
                    productType={TYPE_WARRANTS}
                />
            );
    }

    render() {
        const {
            immBrokerWarrantsSell,
            immStocksContracts,
            immFlagBasedFeatures,
        } = this.props;
        const step1 = immBrokerWarrantsSell.get('steps').get(FIRST_STEP);
        const stocksContractSelectedValue = immBrokerWarrantsSell.getIn(['steps', FIRST_STEP, 'stocksContractSelectedValue']);
        const stockContract = immStocksContracts.find(contract => {
            return contract.get('contactNumber') === stocksContractSelectedValue;
        });

        const contractNumber = stockContract.get('walletNumber');
        const productNumber = stockContract.get('productNumber');
        const chargeAccount = `${CHARGE_ACCOUNT_PREFIX}${productNumber}${contractNumber}`;
        const titlesAmount = step1.get('titleQuantity');
        const operationParams = {
            bondsNumber: titlesAmount,
            chargeAccount: chargeAccount
        };
        const headerInfoText = !__CONTACT_CENTER__  || !immFlagBasedFeatures.get(ETFS_SELL_SHOW_COST) ? (
            <p className="warrants-sell-step2__header-info">
                <FormattedText value="broker-warrantsSellStep2HeaderText" />
            </p>
        ) : null;
        const detailsSubtitle = !immFlagBasedFeatures.get(ETFS_SELL_SHOW_COST) ? (
            <h2 className="warrants-sell-step2__section-title">
                <FormattedText value="broker-warrantsSellStep2Subtitle" />
            </h2>
        ) : null;
        const detailsSection = this.buildDetailsSection();
        const detailsDisclaimer = immFlagBasedFeatures.get(ETFS_SELL_SHOW_COST) ? (
            <div className="warrants-sell-step2__detail-disclaimer">
                <OKMessage type="informative">
                    <FormattedText value="brokerWarrantsSell-exAnteDisclaimerContent" />
                </OKMessage>
            </div>
        ) : null;
        return (
            <div className="warrants-sell-step2">
                <header className="warrants-sell-step2__header">
                    <h2 className="warrants-sell-step2__header-title">
                        <FormattedText value="broker-warrantsSellStep2HeaderTitle" />
                    </h2>
                    {headerInfoText}
                </header>
                <section className="warrants-sell-step2__section">
                    {detailsSubtitle}
                    {detailsSection}
                    {detailsDisclaimer}
                </section>
                <footer className="warrants-sell-step2__section">
                    <SignaturePattern
                        operationType={BROKER_STOCKS_BUY_ID}
                        operationParams={operationParams}
                    />
                </footer>
            </div>
        );
    }
}

BrokerWarrantsSellStep2.propTypes = {
    productFile: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    immBrokerWarrantsSell: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    handleChangeReadChecked: PropTypes.func.isRequired,
    sellWarrantsTransactionCostFun: PropTypes.func.isRequired,
    isinCode: PropTypes.string.isRequired,
    setDocumentsRead: PropTypes.func.isRequired,
    getExAnteData: PropTypes.func.isRequired,
};

module.exports = withRouter(BrokerWarrantsSellStep2);
